import React, { useState } from 'react'
import { LeftOutlined } from "@ant-design/icons";
import { Text } from "../../formitems/Index";
import { useQuery, useMutation } from "@apollo/client";
import { Switch } from "antd";
import { Select } from "antd";
import { notification } from 'antd';
import { Menu, Dropdown } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom'
import {Rank_Query,insertRank,clients,UpdateRank,rankQuery,Delete_Rank} from '../../../Queries/Ranks/rank'

const Fleets = () => {
  const [add_new_Rank, setadd_new_Rank] = useState(false)
  const [val, setval] = useState("")
  const [limit, setlimit] = useState(10)
  const [toggle, settoggle] = useState(true)
  const [val2, setval2] = useState("")
  const [search, setsearch] = useState("")
  const [dropdown, setdropdown] = useState("")
  const [currentFormData, setCurrentFormData] = useState({})
  const [dropdown2, setdropdown2] = useState("")
  const [isEdit, setisEdit] = useState(false)
  const [isView, setisView] = useState(false)
  const { data: datass } = useQuery(clients);
  const { data } = useQuery(rankQuery)
  const { data: dataa } = useQuery(Rank_Query, {
    variables: { active: toggle }
  })

  const [AddRanks, { data: dat }] = useMutation(insertRank, {
    refetchQueries: [{ query: rankQuery }]
  })
  const [UpdateRanks, { data: datasss }] = useMutation(UpdateRank, {
    refetchQueries: [{ query: rankQuery }]
  })
  const add_new_Ranks = () => {
    setadd_new_Rank(true)
  };
  const openNotificationWithIcon = type => {
    notification[type]({
      message: 'Successfully Added Fleet',
      description:
        'Successfully Added fleet Thank you.',
    });
  };
  const NotificationWithIcon = type => {
    notification[type]({
      message: 'Load More Successful',
      description:
        `Now you can see ${limit} fleets`,
    });
  };
  const UpdateNotificationWithIcon = type => {
    notification[type]({
      message: 'Successfully ',
      description:
        `Successfully Update fields`,
    });
  };
  const DeleteNotificationWithIcon = type => {
    notification[type]({
      message: 'Successfully ',
      description:
        `Successfully Delete fields`,
    });
  };
  const PrintNotificationWithIcon = type => {
    notification[type]({
      message: 'Successfully ',
      description:
        `Successfully Print Fleet`,
    });
  };
 
  const editfleet = () => {
    setisEdit(true)
  }
  const View = () => {
    setisView(true)
  }
  const closeForm = () => {
    setadd_new_Rank(false)
    setisEdit(false)
    setisView(false)
  };
  const togle = () => {
    toggle ? settoggle(false) : settoggle(true)
  }
  const handleFormFields = (v, fieldName) => {
    switch (fieldName) {
      case "clientname":
        setCurrentFormData({ ...currentFormData, clientnam: v })
        break;
      case "true":
        setCurrentFormData({ ...currentFormData, active: v })
        break;
      case "rank":
        setCurrentFormData({ ...currentFormData, rank: v })
        break;
      default:
        break;
    }
  }
const emptyState = () => {
  setdropdown2("")
  setdropdown("")
  setval2("")
}
  const menu = (el) => (
    <Menu>
      <Menu.Item>
        <Link onClick={() => {
          setCurrentFormData(el)
          editfleet()
        }}>Edit</Link>
      </Menu.Item>
      <Menu.Item>
        <Link onClick={() => {
          setCurrentFormData(el)
          View()
        }}>View</Link>
      </Menu.Item>
    </Menu>
  )
  const Option = Select.Option;
  return (
    <div className="animate__animated animate__fadeIn">
      {/* Fleet Table */}
      <div className={add_new_Rank || isEdit  || isView ? "hide-element" : ""}>
        <div className="category-title">Ranks</div>
        <button className="submit-button" type="primary" onClick={() => {
          add_new_Ranks()
          emptyState()
        }}>
          Add New Ranks
          </button>
        <div className="table-body-container">
          <div className="table-body-header">All Ranks</div>
          <div className="client-list-divider"></div>
          <div className="table-container">
            <div className="table-header-container">
              <div className="display-record">
                <span>records {limit}</span>
              </div>
              <div className="active-switch">
                <span>Active</span>
                <Switch onClick={togle} defaultChecked />
              </div>
              <div className="search-bar">
                <span>Search Client</span>
                <input type="text" value={search} onChange={(e) => setsearch(e.target.value)} />
              </div>
            </div>
            {toggle}
            {dataa?.aatmsv4_ranks?.map((el, index) => {
              if (el?.clientname?.toLowerCase().includes(search.toLowerCase())) {
                return (
                  <div className="table-row-container" key={index}>
                    <div className="table-row-top">
                      <div className="items">
                        <div className="title">Client</div>
                        <div className="value">{el?.clientname}</div>
                      </div>
                      <div className="items">
                        <div className="title">Rank code</div>
                        <div className="value">{el?.ranksid}</div>
                      </div>
                      <div className="items">
                        <div className="title">Rank Name</div>
                        <div className="value">{el?.rank}</div>
                      </div>
                      <div className="items">
                        <div className="title">Active</div>
                        <div className="value">{el?.active ? "True" : "False"}</div>
                      </div>
                      <Dropdown overlay={menu(el)}>
                        <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                          <i className="fa fa-ellipsis-h" />
                          <DownOutlined />
                        </a>
                      </Dropdown>
                    </div>
                  </div>);}})}
          </div>
        </div>
        <div className="print-email-container">
          <button className="print-button">
            <i className="fa fa-print" />
              Print
            </button>
          <button className="email-button">
            <i className="fa fa-envelope" />
              Email
            </button>
        </div>
      </div>
{/* Add new Rank form */}
      <div className={add_new_Rank ? "" : "hide-element"}>
        <div className="category-title">
          <span className="client-back" onClick={() =>{
            emptyState()
            closeForm()
          } }>
            {<LeftOutlined />} Ranks
            </span>
            Add New Ranks
          </div>
        <div className="toggle-form-container">
          <div className="input-box-container">
            <div className="input-box-title">
              <span>Client</span>
            </div>
            <Select value={dropdown2 ? dropdown2 : "Select Client"}  onChange={e => setdropdown2(e)}>
              {datass?.aatmsv4_clients?.map((el, i) => (
                <Option key={i} value={[el.clientname,el.clientsid]}>{el.clientname}</Option>
              ))}
            </Select> </div>
          <Text title="Rank Name" value={val2} onChange={(e) => setval2(e.target.value)} />
          <div className="input-box-container">
            <div className="input-box-title">
              <span>Active</span>
            </div>
            <Select value={dropdown ? dropdown : "Slect Active"} onChange={e => setdropdown(e)}>
              <Option value={true}>Yes</Option>
            </Select>
          </div>
          <button className="submit-button" onClick={() => {
            AddRanks({ variables: { rankName: val2, clientid: dropdown2[1], clientname:dropdown2[0]} })
            closeForm()
            emptyState()
            openNotificationWithIcon('success')
          }}>Add Rank</button>
          <button onClick={() => closeForm()} className="cancel-button">
            Cancel
          </button>
        </div>
      </div>
{/* Edit Fleet */}
      <div className={isEdit ? "" : "hide-element"}>
        <div className="category-title">
          <span className="client-back" onClick={() => closeForm()}>
            {<LeftOutlined />} Rank
            </span>
            Edit Rank
          </div>
        <div className="toggle-form-container">
          <div className="input-box-container">
            <div className="input-box-title">
            </div>
          <Text disabled title="Client" value={currentFormData?.clientname} onChange={(e) => handleFormFields(e.target.value, "clientname")} />
             </div>
          <Text title="Rank Name" value={currentFormData?.rank} onChange={(e) => handleFormFields(e.target.value, "rank")} />
          <div className="input-box-container">
            <div className="input-box-title">
              <span>Active</span>
            </div>
            <Select defaultValue={currentFormData.active? "No": "Yes"} onChange={(e) => handleFormFields(e, "true")}>
              <Option value={true}>Yes</Option>
              <Option value={false}>No</Option>
            </Select>
          </div>
          <button className="submit-button" onClick={() => {
            UpdateRanks({ variables: {active:currentFormData.active, clientname: currentFormData.clientname,rank: currentFormData?.rank, clientid: currentFormData.clientsid, id: currentFormData?.ranksid } })
            closeForm()
            UpdateNotificationWithIcon("success")
          }}>Update</button>
          <button onClick={() => closeForm()} className="cancel-button">
            Cancel
          </button>
        </div>
      </div>
{/* View */}
      <div className={isView ? "" : "hide-element"}>
        <div className="category-title">
          <span className="client-back" onClick={() => closeForm()}>
            {<LeftOutlined />} Rank
            </span>
            View Rank
          </div>
        <div className="toggle-form-container">
          <div className="input-box-container">
            <div className="input-box-title">
              <span>Client</span>
            </div>
          </div>
          <Text disabled value={currentFormData?.clientname} />
          <Text disabled title="Rank Name" value={currentFormData?.rank} />
          <div className="input-box-container">
            <div disabled className="input-box-title">
              <span>Active</span>
            </div>
            <Text disabled value={currentFormData?.active ? "True": "False"} />
          </div>
          <button className="submit-button" onClick={() => {
            closeForm()
            PrintNotificationWithIcon('success')
          }}>Print Rank</button>
          <button onClick={() => closeForm()} className="cancel-button">
            Cancel
          </button>
        </div>
      </div>
    </div>
  )
}
export default Fleets

